import { Routes } from "@angular/router";



import { AuthGuard } from "./auth/services/auth.guard";





import { StudyPeriodComponent } from "./settings/study-period/study-period.component";
import { PubblicHolidayComponent } from "./settings/pubblic-holiday/pubblic-holiday.component";
import { SubjectsComponent } from "./settings/subjects/subjects.component";
import { DepartmentsComponent } from "./settings/departments/departments.component";
import { OverloadMemoComponent } from "./settings/overload-memo/overload-memo.component";
import { CurriculumTypesComponent } from "./settings/curriculum-types/curriculum-types.component";
import { UsersManagementComponent } from "./settings/users-management/users-management.component";
import { TeachCompensationComponent } from "./teach-compensation/teach-compensation/teach-compensation.component";
import { TeachCompensationDetailsComponent } from "./teach-compensation/teach-compensation-details/teach-compensation-details.component";
import { TeachCompensationPreviewComponent } from "./teach-compensation/teach-compensation-preview/teach-compensation-preview.component";
import { TeachCompensationReviewComponent } from "./teach-compensation/teach-compensation-review/teach-compensation-review.component";
import { TeachCompensationReportComponent } from "./teach-compensation/teach-compensation-report/teach-compensation-report.component";
import { TeachCompensationReportDetailsComponent } from "./teach-compensation/teach-compensation-report-details/teach-compensation-report-details.component";
import { CompensationSummaryDashboardComponent } from "./teach-compensation/compensation-summary-dashboard/compensation-summary-dashboard.component";
import { CompensationSummaryComponent } from "./teach-compensation/compensation-summary/compensation-summary.component";
import { ErpLeaveImportComponent } from "./teach-compensation/erp-leave-import/erp-leave-import.component";
import { OverloadMemoReviewComponent } from "./teach-compensation/overload-memo-review/overload-memo-review.component";
import { ScheduleSubmissionsComponent } from "./schedule-submissions/schedule-submissions/schedule-submissions.component";
import { ScheduleSubmissionsDetailsComponent } from "./schedule-submissions/schedule-submissions-details/schedule-submissions-details.component";
import { ScheduleCorrectionRequestsReviewComponent } from "./schedule-submissions/schedule-correction-requests-review/schedule-correction-requests-review.component";
import { SubjectManagementComponent } from "./subject-management/subject-management/subject-management.component";
import { SubjectManagementDetailsComponent } from "./subject-management/subject-management-details/subject-management-details.component";
import { SubjectManagementCreateComponent } from "./subject-management/subject-management-create/subject-management-create.component";
import { DisbursementCertificationComponent } from "./disbursement-management/disbursement-certification/disbursement-certification.component";
import { DisbursementRegistryComponent } from "./disbursement-management/registry/registry.component";
import {
  COMPENSATION_SUMMARY_ROLE_IDS,
  ERP_LEAVE_IMPORT_ROLE_IDS,
  RoleID,
  OVERLOAD_MEMO_ADMIN_ROLE_IDS,
  OVERLOAD_MEMO_REVIEW_ROLE_IDS,
  SCHEDULE_CORRECTION_REQUEST_REVIEW_ROLE_IDS,
  SUBJECT_MANAGEMENT_EDIT_ROLE_IDS,
  SUBJECT_MANAGEMENT_ROLE_IDS,
  SUBJECT_SCHEDULE_REVIEW_ROLE_IDS,
  SUBJECT_MASTER_DATA_ROLE_IDS,
  SUBJECT_SCHEDULE_ROLE_IDS,
  TEACH_COMPENSATION_MANAGEMENT_ROLE_IDS,
  TEACH_COMPENSATION_ROLE_IDS,
  TEACH_COMPENSATION_REPORT_ROLE_IDS,
  TEACH_COMPENSATION_REVIEW_ROLE_IDS,
  DISBURSEMENT_CERTIFY_ROLE_IDS,
  DISBURSEMENT_DOCUMENT_VIEW_ROLE_IDS,
  DISBURSEMENT_MANAGEMENT_ROLE_IDS,
  DISBURSEMENT_REVISION_REVIEW_ROLE_IDS,
} from "src/utils/enum/role.enum";


const Routing: Routes = [





  {
    path: "compensation-summary-dashboard",
    component: CompensationSummaryDashboardComponent,
    data: {
      toolbar: false,
      roles: COMPENSATION_SUMMARY_ROLE_IDS,
    },
  },
  {
    path: "settings",
    // Relaxed so academic workload managers can reach Master Data : รายวิชา
    // (/settings/subject). The other settings pages stay admin-only via their
    // own data.roles (a child's roles override the parent in AuthGuard).
    data: { toolbar: false, roles: SUBJECT_MASTER_DATA_ROLE_IDS },
    children: [

      {
        path: "study-period",
        component: StudyPeriodComponent,
        data: {
          toolbar: false,
          roles: [RoleID.ADMIN],
        },
      },
      {
        path: "pubblic-holiday",
        component: PubblicHolidayComponent,
        data: {
          toolbar: false,
          roles: [RoleID.ADMIN],
        },
      },
      {
        path: "subject",
        component: SubjectsComponent,
        data: {
          toolbar: false,
          roles: SUBJECT_MASTER_DATA_ROLE_IDS,
        },
      },
      {
        path: "departments",
        component: DepartmentsComponent,
        data: {
          toolbar: false,
          roles: [RoleID.ADMIN],
        },
      },
      {
        path: "curriculum-types",
        component: CurriculumTypesComponent,
        data: {
          toolbar: false,
          roles: [RoleID.ADMIN],
        },
      },
      {
        path: "users-management",
        component: UsersManagementComponent,
        data: {
          toolbar: false,
          roles: [RoleID.ADMIN],
        },
      },
      {
        path: "overload-memo",
        component: OverloadMemoComponent,
        data: {
          toolbar: false,
          roles: OVERLOAD_MEMO_ADMIN_ROLE_IDS,
        },
      },
      // v1.2 decision 6: settings/disbursement (จัดการบันทึกข้อความขอเบิกค่าสอนชดเชย)
      // is deleted — it was a misunderstanding (no second memo exists; the
      // flow's attached memo is Page A's overload memo above). The dev-only
      // re-provision trigger moved to the ข้อมูลเอกสารส่งเบิก page
      // (disbursement-management/registry), gated on
      // environment.enableDisbursementTestTrigger.
      // A3 (per-user signature upload/replace) removed — A6.2: signature-image
      // upload is out of scope system-wide; disbursement PDFs print the
      // certifier's name instead.
      // A5 (email-templates) intentionally skipped — deferred per
      // plan-flow-abstract-pie.md's Phase E summary ("email templates page =
      // later/net-new"); see final build report.

    ],
  },
  {
    path: "teach-compensation-management",
    data: { toolbar: false, roles: TEACH_COMPENSATION_MANAGEMENT_ROLE_IDS },
    children: [

      {
        path: "teach-compensation",
        component: TeachCompensationComponent,
        data: {
          toolbar: false,
          roles: TEACH_COMPENSATION_ROLE_IDS,
        },
      },
      {
        path: "teach-compensation-details",
        component: TeachCompensationDetailsComponent,
        data: {
          toolbar: false,
          roles: TEACH_COMPENSATION_ROLE_IDS,
        },
      },
      {
        path: "teach-compensation-preview/:id",
        component: TeachCompensationPreviewComponent,
        data: {
          toolbar: false,
          roles: TEACH_COMPENSATION_ROLE_IDS,
        },
      },
      {
        path: "teach-compensation-review",
        component: TeachCompensationReviewComponent,
        data: {
          toolbar: false,
          roles: TEACH_COMPENSATION_REVIEW_ROLE_IDS,
        },
      },
      {
        path: "teach-compensation-report",
        component: TeachCompensationReportComponent,
        data: {
          toolbar: false,
          roles: TEACH_COMPENSATION_REPORT_ROLE_IDS,
        },
      },
      {
        path: "teach-compensation-report/:scheduleSubmissionId",
        component: TeachCompensationReportDetailsComponent,
        data: {
          toolbar: false,
          roles: TEACH_COMPENSATION_REPORT_ROLE_IDS,
        },
      },
      {
        path: "compensation-summary",
        component: CompensationSummaryComponent,
        data: {
          toolbar: false,
          roles: COMPENSATION_SUMMARY_ROLE_IDS,
        },
      },
      {
        path: "erp-leave-import",
        component: ErpLeaveImportComponent,
        data: {
          toolbar: false,
          roles: ERP_LEAVE_IMPORT_ROLE_IDS,
        },
      },
      {
        path: "overload-memo-review",
        component: OverloadMemoReviewComponent,
        data: {
          toolbar: false,
          roles: OVERLOAD_MEMO_REVIEW_ROLE_IDS,
        },
      },

    ],
  },
  {
    // Disbursement Document Certification — จัดการเอกสารส่งเบิก, v1.2 (UAM r21/r22).
    // "disbursement-certification" (r22 ตรวจสอบและอนุมัติเอกสารส่งเบิก) carries the
    // vice_dean_academic revision-review tab too, so its own data.roles is the
    // union of certify + revision-review. "registry" (r21 ข้อมูลเอกสารส่งเบิก) is
    // the merged display page for all six VE roles — สารบัญ additionally sees
    // the per-department ZIP download block on that same page. Mirrors
    // `teach-compensation-management` (lazy standalone routes, in-page detail
    // — no `:id` route).
    path: "disbursement-management",
    data: { toolbar: false, roles: DISBURSEMENT_MANAGEMENT_ROLE_IDS },
    children: [

      {
        path: "disbursement-certification",
        component: DisbursementCertificationComponent,
        data: {
          toolbar: false,
          roles: Array.from(new Set([
            ...DISBURSEMENT_CERTIFY_ROLE_IDS,
            ...DISBURSEMENT_REVISION_REVIEW_ROLE_IDS,
          ])),
        },
      },
      {
        // r21 ข้อมูลเอกสารส่งเบิก — per-cert rows of completed certs only, role-
        // scoped server-side (teacher own / head own dept / others all).
        path: "registry",
        component: DisbursementRegistryComponent,
        data: {
          toolbar: false,
          roles: DISBURSEMENT_DOCUMENT_VIEW_ROLE_IDS,
        },
      },

    ],
  },
  {
    path: "schedule-submissions-management",
    data: { toolbar: false, roles: SUBJECT_SCHEDULE_ROLE_IDS },
    children: [

      {
        path: "schedule-submissions",
        component: ScheduleSubmissionsComponent,
        data: {
          toolbar: false,
          approvalReview: false,
        },
      },
      {
        path: "schedule-submissions-details/:id",
        component: ScheduleSubmissionsDetailsComponent,
        data: {
          toolbar: false,
          approvalReview: false,
        },
      },
      {
        path: "schedule-submissions-review",
        component: ScheduleSubmissionsComponent,
        data: {
          toolbar: false,
          approvalReview: true,
          roles: SUBJECT_SCHEDULE_REVIEW_ROLE_IDS,
        },
      },
      {
        path: "schedule-submissions-review-details/:id",
        component: ScheduleSubmissionsDetailsComponent,
        data: {
          toolbar: false,
          approvalReview: true,
          roles: SUBJECT_SCHEDULE_REVIEW_ROLE_IDS,
        },
      },
      {
        path: "schedule-correction-requests-review",
        component: ScheduleCorrectionRequestsReviewComponent,
        data: {
          toolbar: false,
          roles: SCHEDULE_CORRECTION_REQUEST_REVIEW_ROLE_IDS,
        },
      },

    ],
  },
  {
    path: "subject-management/details",
    data: { toolbar: false, roles: SUBJECT_MANAGEMENT_ROLE_IDS },
    component: SubjectManagementDetailsComponent,
  },
  {
    path: "subject-management/create",
    data: { toolbar: false, roles: SUBJECT_MANAGEMENT_EDIT_ROLE_IDS },
    component: SubjectManagementCreateComponent,
  },
  {
    path: "subject-management",
    data: { toolbar: false, roles: SUBJECT_MANAGEMENT_ROLE_IDS },
    component:SubjectManagementComponent
  },
  {
    path: "",
    redirectTo: "/settings/study-period",
    pathMatch: "full",
  },
  {
    path: "**",
    redirectTo: "dashboard",
  },
  // {
  //   path: "**",
  //   redirectTo: "error/404",
  // },
];

export { Routing };
